import { formatPlacementPreview, buildPlacementBidding } from '@/utils/spCampaignCreateDraft';

export function BidAdjustmentsFields({
  topOfSearch,
  restOfSearch,
  productPages,
  onTopOfSearchChange,
  onRestOfSearchChange,
  onProductPagesChange,
  defaultBid,
  disabled,
}: {
  topOfSearch: string;
  restOfSearch: string;
  productPages: string;
  onTopOfSearchChange: (value: string) => void;
  onRestOfSearchChange: (value: string) => void;
  onProductPagesChange: (value: string) => void;
  defaultBid: string;
  disabled?: boolean;
}) {
  const preview = formatPlacementPreview(defaultBid, buildPlacementBidding({
    topOfSearch,
    restOfSearch,
    productPages,
  }));

  return (
    <fieldset className="border border-border rounded-xl p-4 space-y-3">
      <legend className="text-sm font-medium text-foreground-muted px-1">Bid adjustments</legend>
      <p className="text-xs text-foreground-muted">
        By raising your bids, you'll be more likely to appear in specific placements.
      </p>
      <p className="text-sm text-foreground">Increase your bid for specific Amazon placements.</p>
      {(
        [
          ['Top of search (first page)', topOfSearch, onTopOfSearchChange],
          ['Rest of search', restOfSearch, onRestOfSearchChange],
          ['Product pages', productPages, onProductPagesChange],
        ] as const
      ).map(([label, value, onChange]) => (
        <div key={label} className="flex items-center justify-between gap-3">
          <label className="text-sm text-foreground">{label}</label>
          <div className="flex items-center gap-1">
            <input
              type="number"
              min="0"
              step="1"
              value={value}
              onChange={(e) => onChange(e.target.value)}
              className="w-20 border border-border rounded-lg px-2 py-1 text-sm text-right"
              disabled={disabled}
            />
            <span className="text-sm text-foreground-muted">%</span>
          </div>
        </div>
      ))}
      <p className="text-xs text-foreground-subtle">{preview}</p>
    </fieldset>
  );
}
